import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

const ENTER_KEY = 13;

/**
 * Wrapper:
 *  - Wrapper for Menu in Notebook/MenuList
 */
export const Wrapper = React.forwardRef(function Wrapper(props, ref) {
  const className = `${style.wrap} ${props.className}`;

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onEnterKey();

  return (
    <div
      ref={ref}
      className={className}
      role="button"
      onClick={props.onClick}
      onKeyDown={onKeyDown}
      tabIndex={props.tabIndex}
      style={{ cursor: "pointer" }}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </div>
  );
});

Wrapper.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Callback for onClick Event
   */
  onClick: PropTypes.func,
  /**
   * Callback for when ENTER key is clicked
   */
  onEnterKey: PropTypes.func,
  /**
   * Child components
   */
  children: PropTypes.arrayOf(PropTypes.element),
  /**
   * Accessible label for screen readers
   */
  ariaLabel: PropTypes.string,
};

Wrapper.defaultProps = {
  className: "",
};
